import React from 'react'
import clsx from 'clsx'

import { Text } from '@wartek-id/text'

type TProfileNotificationProps = {
  children: React.ReactNode
  className?: string
}
const Notification = ({
  children,
  className,
  ...props
}: TProfileNotificationProps) => {
  return (
    <div
      className={clsx('px-4 py-3 bg-surface-neutral-subdued', className)}
      {...props}
    >
      <Text variant="helper">{children}</Text>
    </div>
  )
}

export default Notification
